import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { FormGroup } from "@angular/forms";
import { PhotoService } from "../../../photo/services/photo.service";
import { PresetService } from "../../../../shared/services/preset.service";
import { FormlyFieldConfig } from "@ngx-formly/core";
import * as moment from "moment";
import { ActivatedRoute } from "@angular/router";
import AppShareHelper from "../../../../shared/utils/helper";
import { GroupService } from "../../../user/services/group.service";

@Component({
    selector: 'app-preset-form-component',
    templateUrl: './preset-form-component.html',
})
export class PresetFormComponent {
    static STATUS = {
        DRAFT: 'draft',
        IN_PROGRESS: 'in_progress',
        COMPLETED: 'completed',
    }
    
    inProgressStatus = PresetFormComponent.STATUS.IN_PROGRESS
    model: any = {
        name : '',
        description : '',
        type : 'normal',
        status : 'draft',
        category: 'most_talked',
        photoIds: null,
        startTime: null,
        endTime: null,
    };
    enModel: any = {
        name : '',
        shortDescription: '',
        description : ''
    }
    pointModel: any = {
        point: null,
        objectId: null,
    };
    testingMode = false;
    form = new FormGroup({});
    photos = [];
    groupId = null;
    groupHide = false;
    minDate = moment().format(moment.HTML5_FMT.DATETIME_LOCAL);
    groupForm = new FormGroup({});
    groupFields: FormlyFieldConfig[] = [
        {
            key: 'groupSearchValue',
            type: 'autocomplete',
            className: 'form-mb-0',
            expressionProperties : {
                'templateOptions.disabled': () => {
                    return this.model.id
                },
            },
            templateOptions: {
                type: 'text',
                placeholder: 'Find photo club by name',
                required: false,
                change: (field, event) => {
                },
                autoOptions: {
                    isMapIcon: false,
                    clearOption: true,
                    displayField: 'title',
                    selectItem: (event, model) => {
                        setTimeout(() => {
                            this.groupId = model.groupSearchValue.id
                        }, 100)
                    },
                    clearItem: (event, model) => {
                        if (this.model.id) return;
                        setTimeout(() => {
                            this.groupId = null;
                            this.groupForm.controls['groupSearchValue'].setValue({})
                        }, 100)
                    },
                    inputFormatter: (x) => {
                        return (typeof x === 'object') ? x['title'] : x;
                    },
                    remoteData: (term) => {
                        return this.groupService.searchGroup(term);
                    },
                }
            },
        },
    ]
  
    fields: FormlyFieldConfig[] = [
        {
            key: 'startTime',
            type: 'datepicker',
            templateOptions: {
                pickerType: 'both',
                displayIcon: true,
            }
        }
    ];
    
    @Output()
    onRefresh: EventEmitter<any> = new EventEmitter<any>();
    
    constructor(
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        public photoService: PhotoService,
        public presetService: PresetService,
        public groupService: GroupService,
        protected toastr: ToastrService
    ) {
    }
    
    ngOnInit() {
        this.testingMode = this.route.snapshot.queryParams.testingMode;
        
        if (this.groupId) {
            this.model.type = 'battle';
        }
        
        if (this.model.language && this.model.language.en) {
            this.enModel = this.model.language.en
        }
        
        if (this.model.photoIds) {
            if (this.model.type == 'battle') {
                this.model.startTime = moment(this.model.startTime).format(moment.HTML5_FMT.DATETIME_LOCAL);
                this.model.endTime = moment(this.model.endTime).format(moment.HTML5_FMT.DATETIME_LOCAL);
            }
            
            if (this.model.status == PresetFormComponent.STATUS.IN_PROGRESS ||
                this.model.status == PresetFormComponent.STATUS.COMPLETED
            ) {
                this.presetService.getBattlePresetResult(this.model.id).toPromise().then((result: any) => {
                    this.preview(result.Data.result || []);
                    return;
                })
            }
            
            this.preview();
        }
    }
    
    createPreset(form) {
        if (form.valid) {
            let savePresetObs = null;
            const sendingParams = AppShareHelper.deepClone(this.model);
            if (this.model.startTime && this.model.status != this.inProgressStatus) {
                const selectedStartTime = new Date(this.model.startTime);
                const selectedEndTime = new Date(this.model.endTime);
        
                if (selectedStartTime < (new Date())) {
                    this.toastr.error('The time select need should be in future', 'Error');
                    return;
                }
        
                if (selectedEndTime < selectedStartTime) {
                    this.toastr.error('The end time should be later than Start time ', 'Error');
                    return;
                }
        
                if (selectedStartTime.getMinutes() != 0 || selectedEndTime.getMinutes() != 0) {
                    this.toastr.error('The minute should be 00 (Fex : 9:00, 10:00)', 'Error');
                    return;
                }
    
                sendingParams.startTime = selectedStartTime;
                sendingParams.endTime = selectedEndTime;
            }
    
            sendingParams.language = {
                en: this.enModel
            }
            
            if (this.groupId) {
                sendingParams.groupId = this.groupId;
            }
            
            if (this.model.id) {
                if (this.model.startTime && this.model.status == this.inProgressStatus) {
                    sendingParams.startTime = moment(this.model.startTime);
                    sendingParams.endTime = moment(this.model.endTime);
                }
                savePresetObs = this.presetService.updatePreset(sendingParams)
            } else {
                savePresetObs = this.presetService.createPreset(sendingParams);
            }
            
            savePresetObs.toPromise().then(res => {
                this.activeModal.close();
                this.toastr.success('Save preset successfully', 'SUCCESS');
                this.onRefresh.emit();
            })
        }
    }
    
    addPoint() {
        if (this.pointModel.objectId && this.pointModel.point) {
            this.pointModel.presetId = this.model.id;
            this.presetService.addPoint(this.pointModel).subscribe((res) => {
                this.toastr.success('Add point successfully', 'SUCCESS');
                this.pointModel.objectId = this.pointModel.point = null;
                this.activeModal.close();
            })
        } else {
            this.toastr.error('The photoId, point field can not be empty', 'Error');
        }
    }
    
    preview(result = []) {
        if (this.model.photoIds) {
            this.model.photoIds = this.model.photoIds.replace(/ /g,'');
            const photoIdsArr = this.model.photoIds.split(",");
            const orderedPhotos = [];
            const photoObjects = {}
            const parsedResult = {}
            result.forEach((item) => {
                parsedResult[item.objectId] = item.score;
            })
            
            this.photoService.getPhotosById(photoIdsArr, 100, 0, this.groupId).toPromise().then((res: any) => {
                if (res.Data && res.Data.length) {
                    res.Data.forEach((item) => {
                        photoObjects[item.id] = item;
                    })
                    
                    photoIdsArr.forEach(id => {
                        if (photoObjects[id]) {
                            photoObjects[id].score = parsedResult[id];
                            orderedPhotos.push(photoObjects[id]);
                        }
                    })
                    this.photos = orderedPhotos;
                }
            })
        } else {
            this.toastr.error('Please input photoIds!', 'Error');
        }
    }
}
